/**
 * @generated SignedSource<<fd9311657eaa01c51e8c90756978bbda>>
 * @relayHash 640c23eb6f745c6be63cf05f1858ddd8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7ba2b403bb5abffbe8b2c8a21ec9da0db5d6be64e5f00a24db3fbf799cc8394d

import type { ConcreteRequest } from 'relay-runtime';
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type DualStreamQueriesFirstPageQuery$variables = {
  cloudId: string;
  contentId: string;
  first?: number | null;
  includeDevDocsSyncStatus?: boolean | null;
  parentId: string;
  spaceKey?: string | null;
};
export type DualStreamQueriesFirstPageQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly emojiTitlePublished: string | null;
      readonly id: string;
      readonly links: {
        readonly webui: string | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly status: PTGraphQLPageStatus | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly folders: {
    readonly nodes: ReadonlyArray<{
      readonly emojiTitlePublished: string | null;
      readonly id: string;
      readonly links: {
        readonly webui: string | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly status: PTGraphQLPageStatus | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly ptpage: {
    readonly id: string;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly singleContent: {
    readonly devDocsProperties?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
    } | null> | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type DualStreamQueriesFirstPageQuery = {
  response: DualStreamQueriesFirstPageQuery$data;
  variables: DualStreamQueriesFirstPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": 100,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeDevDocsSyncStatus"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "title"
},
v8 = {
  "kind": "ScalarField",
  "name": "type"
},
v9 = {
  "kind": "ScalarField",
  "name": "subType"
},
v10 = {
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "parentId"
    },
    {
      "kind": "Literal",
      "name": "status",
      "value": [
        "CURRENT",
        "DRAFT"
      ]
    }
  ],
  "concreteType": "PTPage",
  "kind": "LinkedField",
  "name": "ptpage",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/)
  ]
},
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v12 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    }
  ]
},
v13 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v6/*: any*/),
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
],
v14 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v15 = {
  "condition": "includeDevDocsSyncStatus",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "devDocsProperties",
      "args": [
        {
          "kind": "Literal",
          "name": "keys",
          "value": [
            "devdocsProperties"
          ]
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v13/*: any*/),
      "storageKey": "properties(keys:[\"devdocsProperties\"])"
    }
  ]
},
v16 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v17 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v18 = {
  "kind": "Variable",
  "name": "parentId",
  "variableName": "parentId"
},
v19 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v20 = [
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "FOLDER"
  }
],
v21 = {
  "kind": "ScalarField",
  "name": "status"
},
v22 = {
  "kind": "ScalarField",
  "name": "emojiTitlePublished"
},
v23 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v24 = {
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v13/*: any*/)
},
v25 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v26 = [
  {
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v6/*: any*/),
      (v7/*: any*/),
      (v21/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/)
    ]
  },
  (v25/*: any*/)
],
v27 = [
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "CONTENT"
  }
],
v28 = [
  {
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      (v6/*: any*/),
      (v7/*: any*/),
      (v21/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/)
    ]
  },
  (v25/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DualStreamQueriesFirstPageQuery",
    "selections": [
      (v10/*: any*/),
      {
        "args": (v11/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/)
        ]
      },
      {
        "alias": "folders",
        "args": (v20/*: any*/),
        "concreteType": "ConfluenceContentTreeItemConnection",
        "kind": "LinkedField",
        "name": "confluence_contentTreeChildren",
        "plural": false,
        "selections": (v26/*: any*/)
      },
      {
        "alias": "content",
        "args": (v27/*: any*/),
        "concreteType": "ConfluenceContentTreeItemConnection",
        "kind": "LinkedField",
        "name": "confluence_contentTreeChildren",
        "plural": false,
        "selections": (v26/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "DualStreamQueriesFirstPageQuery",
    "selections": [
      (v10/*: any*/),
      {
        "args": (v11/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v6/*: any*/)
        ]
      },
      {
        "alias": "folders",
        "args": (v20/*: any*/),
        "concreteType": "ConfluenceContentTreeItemConnection",
        "kind": "LinkedField",
        "name": "confluence_contentTreeChildren",
        "plural": false,
        "selections": (v28/*: any*/)
      },
      {
        "alias": "content",
        "args": (v27/*: any*/),
        "concreteType": "ConfluenceContentTreeItemConnection",
        "kind": "LinkedField",
        "name": "confluence_contentTreeChildren",
        "plural": false,
        "selections": (v28/*: any*/)
      }
    ]
  },
  "params": {
    "cacheID": "640c23eb6f745c6be63cf05f1858ddd8",
    "id": "7ba2b403bb5abffbe8b2c8a21ec9da0db5d6be64e5f00a24db3fbf799cc8394d",
    "metadata": {},
    "name": "DualStreamQueriesFirstPageQuery",
    "operationKind": "query",
    "text": "query DualStreamQueriesFirstPageQuery($cloudId:ID!,$parentId:ID!,$spaceKey:String,$contentId:ID!,$first:Int=100,$includeDevDocsSyncStatus:Boolean=false){ptpage(id:$parentId,status:[CURRENT,DRAFT]){id,title,type,subType},singleContent(id:$contentId){operations{operation},properties(keys:[\"smartFolderProperties\"]){nodes{id,key,value}},devDocsProperties:properties(keys:[\"devdocsProperties\"])@include(if:$includeDevDocsSyncStatus){nodes{id,key,value}},id},folders:confluence_contentTreeChildren(cloudId:$cloudId,parentId:$parentId,spaceKey:$spaceKey,type:FOLDER,first:$first){nodes{__typename,id,title,status,type,subType,emojiTitlePublished,links{webui},properties{nodes{id,key,value}}},pageInfo{hasNextPage,endCursor}},content:confluence_contentTreeChildren(cloudId:$cloudId,parentId:$parentId,spaceKey:$spaceKey,type:CONTENT,first:$first){nodes{__typename,id,title,status,type,subType,emojiTitlePublished,links{webui},properties{nodes{id,key,value}}},pageInfo{hasNextPage,endCursor}}}"
  }
};
})();

(node as any).hash = "db6a0e93da291f17514931ed70e432eb";

export default node;
